import { Reveal, SectionTag, StarDoodle } from "@/components/doodles";

const CHAPTERS = [
  {
    n: "01",
    title: "MEET YOUR BODY WHERE IT IS",
    copy: "Every plan starts with an honest look at your season, your history, your capacity. No comparison traps. No copy-paste programs.",
    note: "start where you are!",
  },
  {
    n: "02",
    title: "PROGRESS OVER PUNISHMENT",
    copy: "Progressive overload that respects recovery. We train hard because we're consistent — not because we're atoning for lunch.",
    note: "no burnout allowed",
  },
  {
    n: "03",
    title: "MINDSET OVER MIRROR",
    copy: "We chase capability: first pull-ups, heavy lifts, healthy knees. Confidence is the side effect that follows you out of the gym.",
    note: "strong is the goal",
  },
  {
    n: "04",
    title: "FAITH • GRIT • GROWTH",
    copy: "Training with purpose: encouragement, discipline, and growth that reach past the gym walls into the rest of your life.",
    note: "rooted & rising",
  },
];

export const Philosophy = () => (
  <section id="philosophy" className="py-24 sm:py-32 bg-offwhite border-y-[3px] border-ink">
    <div className="max-w-6xl mx-auto px-5 sm:px-8">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
        <div>
          <Reveal><SectionTag className="text-royal">MY TRAINING PHILOSOPHY</SectionTag></Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-display font-extrabold uppercase text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-3 leading-[0.95]">
              THE EVOLVE <span className="hl-lime">MANIFESTO</span>.
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.1}>
          <p className="font-hand text-2xl sm:text-3xl text-pink -rotate-1">four rules I coach by ↓</p>
        </Reveal>
      </div>

      <div className="mt-14 border-t-[3px] border-ink" data-testid="philosophy-manifesto">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.n} delay={i * 0.05}>
            <div
              className="grid lg:grid-cols-[auto_1fr_auto] gap-6 lg:gap-12 items-center py-10 border-b-[3px] border-ink group hover:bg-cream transition-colors duration-200 px-2 sm:px-4"
              data-testid={`philosophy-chapter-${i + 1}`}
            >
              <p className="font-display font-extrabold text-7xl sm:text-8xl lg:text-9xl leading-none text-stroke group-hover:text-pink group-hover:[-webkit-text-stroke:0px] transition-all duration-200">
                {c.n}
              </p>
              <div>
                <h3 className="font-display font-extrabold uppercase text-2xl sm:text-3xl lg:text-4xl tracking-tight">{c.title}</h3>
                <p className="mt-3 text-base sm:text-lg font-semibold text-ink/70 max-w-2xl leading-relaxed">{c.copy}</p>
              </div>
              <div className="flex items-center gap-2 lg:flex-col lg:items-end">
                <StarDoodle className="w-5 h-5 text-gold" />
                <p className="font-hand text-2xl text-royal rotate-2">{c.note}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
